import { render, staticRenderFns } from "./ui-checkbox.vue?vue&type=template&id=d47f4cfe&"
import script from "./ui-checkbox.vue?vue&type=script&lang=js&"
export * from "./ui-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./ui-checkbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d47f4cfe')) {
      api.createRecord('d47f4cfe', component.options)
    } else {
      api.reload('d47f4cfe', component.options)
    }
    module.hot.accept("./ui-checkbox.vue?vue&type=template&id=d47f4cfe&", function () {
      api.rerender('d47f4cfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/kit/ui-checkbox/ui-checkbox.vue"
export default component.exports